import * as types from '../mutation-types'

export default {
	namespaced: true,

	state: {
		priceTypes: []
	},

	actions: {
		fetchAll({ commit }) {
			return window.axios.get('/price').then(({ data }) => {
				commit(types.STORE_PRICE_TYPES, data)
				return data;
			})
		}
	},

	mutations: {
		[types.STORE_PRICE_TYPES](state, priceTypes) {
			state.priceTypes = priceTypes;
		}
	},

	getters: {
		getPriceTypeById: state => id => state.priceTypes.find(c => c.id === id)
	}
}